<template>
  <div :class="s.approximateWarning">※ 予約時に正確な位置情報を特定できませんでした。マップの案内が正確でない場合がありますので、住所をご確認の上お向かい下さい。</div>
</template>

<script>
export default {
  name: 'approximate-warning',
};
</script>

<style lang="scss" module="s">
.approximateWarning {
  color: var(--primary-red);
  font-size: 12px;
  margin-top: 4px;
}
</style>
